import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_JOB_SERVICE}`
);

const getPendingAssessments = async (userId?: string) => {
  try {
    const response = await axios.get(`/pending-tests/`, {
      params: {
        id: userId,
      },
    });

    return response.data;
  } catch (error: unknown) {
    throw error;
  }
};

const applyAdditionalInfo = async (assessmentDetails: any) => {
  try {
    const response = await axios.post(`/apply-additional-info`, {
      ...assessmentDetails,
    });

    return response.data;
  } catch (error: unknown) {
    throw error;
  }
};

const validateAssessment = async (
  userId: string,
  jobId: string | number,
  recruiterId: string
) => {
  try {
    const response = await axios.get(`/validate-assessment/`, {
      params: {
        seekerId: userId,
        jobId,
        recruiterId,
      },
    });

    return response.data;
  } catch (error: unknown) {
    throw error;
  }
};

const pendingAssessmentService = {
  getPendingAssessments,
  applyAdditionalInfo,
  validateAssessment,
};

export default pendingAssessmentService;
